<template>
  <div class="header">
    <!-- <div class="logo"></div> -->
    <div class="navBox">
      <div
        :class="['navItem', item.key == currentNav ? 'cur' : '']"
        @click="tipsAlert(item)"
        v-for="item in navlist"
        :key="item.key"
      >
        <router-link :to="item.tips ? '' : item.url">
          {{ item.text }}
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "navigation",
  data() {
    return {
      navlist: [
        {
          url: "/",
          text: "首页",
          key: "index",
          tips: "",
        },
        {
          url: "/memberInfo",
          text: "会员风采",
          key: "memberInfo",
          tips: "",
        },
        {
          url: "/announcement",
          text: "通知公告",
          key: "announcement",
          tips: "",
        },
        {
          url: "/professional",
          text: "行业人才",
          key: "professional",
          tips: "",
        },
        {
          url: "/resourceSharing",
          text: "资源共享",
          key: "resourceSharing",
          tips: "",
        },
        {
          url: "/committee",
          text: "专业委员会",
          key: "committee",
          tips: "",
        },
        {
          url: "/industryNews",
          text: "行业动态",
          key: "industryNews",
          tips: "",
        },
        {
          url: "/company?key=AssociationIntro",
          text: "关于我们",
          key: "company",
          tips: "",
        },
      ],
    };
  },
  computed: {
    currentNav: {
      get() {
        return this.$store.state.currentNav;
      },
      set(val) {
        return this.$store.commit("updateCurrentNav", val);
      },
    },
  },
  methods: {
    tipsAlert($val) {
      // console.log(666);
      if (!$val.tips) return;
      this.$alert($val.tips, "提示", {
        confirmButtonText: "确定",
        // callback: (action) => {
        //   console.log(action);
        // },
      });
    },
  },
  watch: {
    // '$route' (res) {
    // 	console.log('路由变化')
    // 	console.log(res)
    // }
    $route: {
      handler(newName) {
        let navData = {
          index: "index",
          memberInfo: "memberInfo",
          memberInfoDetails: "memberInfo",
          announcement: "announcement",
          announcementDetails: "announcement",
          professional: "professional",
          professionalDetails: "professional",
          // vocational: "vocational",
          // vocationalDetails: "vocational",
          resourceSharing: "resourceSharing",
          resourceSharingDetails: "resourceSharing",
          committee: "committee",
          committeeDetails: "committee",
          industryNews: "industryNews",
          industryNewsDetails: "industryNews",
          company: "company",
        };
        this.currentNav = navData[newName.name];
        // this.$store.commit("updateCurrentNav", newName.name);
        // console.log(newName);
        // console.log(oldName);
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
$header_height: 78px;
.header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  width: 1180px;
  height: $header_height;
  // position: absolute;
  // top: 30px;
  // left: 50%;
  // transform: translate(-50%, 0);
  margin: 0 auto;
  z-index: 6;
  // .logo {
  //   flex-shrink: 0;
  //   width: 264px;
  //   height: 43px;
  //   background: url("../../assets/img/common/logo_top.png") no-repeat;
  //   background-size: cover;
  // }
  .navBox {
    display: flex;
    width: 1180px;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    height: $header_height;
    // min-width: 800px;
    position: relative;
    .navItem {
      flex: 1;
      &.cur a,
      &:hover a {
        color: #fff;
        background-color: #003b99;
        &::before {
          display: none;
        }
      }
      a {
        width: 100%;
        // min-width: 100px;
        height: $header_height;
        line-height: $header_height;
        font-size: 18px;
        color: #333333;
        white-space: nowrap;
        text-decoration: none;
        text-align: center;
        position: relative;
        z-index: 6;
        background-color: #fff;
        transition: 0.4s;
        &:last-child::before {
          display: none;
        }
        &::before {
          content: "";
          display: block;
          width: 1px;
          height: 26px;
          position: absolute;
          top: 50%;
          right: 0;
          z-index: -1;
          transform: translate(0, -50%);
          background-color: #cccccc;
        }
      }
    }
  }
}
</style>
